let project = window.fe.project
const feedback = {
  getConfig: {
    url: `/${project}/feedback/isSupport`,
    type: 'get'
  },
  // 附件上传
  upload: {
    url: `/${project}/feedback/upload`,
    type: 'get'
  },
  // 新建意见反馈保存
  save: {
    url: `/${project}/feedback/create`,
    type: 'post',
    parameter: {
      title: String,
      feedbackPersonName: String,
      feedbackPersonMobile: String,
      feedbackType: Number,
      feedbackContent: String,
      accessorys: Array
    }
  }
}
export default feedback
